import { ActionButton, Icon } from '@fluentui/react';
import { Utils } from '../../../common/views/Utils';
import { PhoneModel } from '../../models/PhoneModel';
import telegram from "../../../../assets/images/telegram.jpg";
import DefaultTextView from '../../../common/views/DefaultTextView';

export type PhoneItemProps = {
    phone: PhoneModel;
    onEdit: (phone: PhoneModel) => void;
    onDelete: (phone: PhoneModel) => void;
    onSelect?: (phone: PhoneModel) => void;
}

export default function PhoneItemView({ phone, onEdit, onDelete, onSelect }: PhoneItemProps) {
    const width4 = Utils.getColumnWidth(4);
    const width6 = Utils.getColumnWidth(6);
    const width8 = Utils.getColumnWidth(8);
    const width12 = Utils.getColumnWidth(12);

    const row1 = () => {
        return <div className="ms-Grid-row">
            <div className={width8 + " left"}>
                {Utils.formatKhPhone(phone.countryCode, phone.phoneNo)}
            </div>
            <div className={width4 + " right"}>{phone.isPrimary && <>
                <DefaultTextView text="default" />
            </>}</div>
        </div>
    }

    const row2 = () => {
        return <div className="ms-Grid-row pt-15">
            <div className={width12 + " left container"}>
                <img src={telegram} alt="Telegram" style={{ width: "15px" }} />
                <div className="pl-5" style={{ marginTop: -3 }}>Telegram Available</div>
            </div>
        </div>
    }

    const actionRow = () => {
        return <div className="ms-Grid-row default-toolbar">
            <div className={width4 + " left"}>
                <ActionButton
                    iconProps={{ iconName: "Edit" }}
                    onClick={() => onEdit(phone)}
                >Edit</ActionButton>
            </div>
            <div className={width4 + " center"}>
                {onSelect && <>
                    <ActionButton
                        iconProps={{ iconName: "CircleRing" }}
                        onClick={() => onSelect(phone)}
                    >Select</ActionButton>
                </>}
            </div>
            <div className={width4 + " right"}>
                <ActionButton
                    iconProps={{ iconName: "Delete" }}
                    onClick={() => onDelete(phone)}
                >Delete</ActionButton>
            </div>
        </div>;
    }

    return <div className="ph-15">
        <div className="ms-Grid pt-10 default-border">
            <div className="pt-5 pb-15 ph-5">
                {row1()}
                {phone.telegram && row2()}
            </div>

            {actionRow()}
        </div>
    </div>;
}